import React from "react";
import { useSelector } from "react-redux";

export const CommonLoader = () => {
  const loadingCount = useSelector((state)=> state.loader.loadingCount);
  const isLoading = loadingCount > 0;
  if(!isLoading) return null;

  return (
    <>
    <div class="bar-inner">
      <div class="bar-in"></div>
    </div>
    </>
  );
};
